module.exports = __webpack_public_path__ + "img/98.3.9efee301.png";